function replaceVariables(inputString, response, rt, correct, offset) {
    if (inputString && inputString.indexOf('%') < 0) {
        return inputString;
    }

    if (response === undefined) {
        response = window.allResponses[window.allResponses.length - 1];
    }
    if (rt === undefined) {
        rt = window.allRTs[window.allRTs.length - 1];
    }

    if (correct === undefined) {
        correct = window.allCorrects[window.allCorrects.length - 1];
    }

    if (offset === undefined) {
        offset = 0;
    }

    responseCode = window.allResponseCodes[window.allResponseCodes.length - 1];

    inputString = inputString.replace(/%response%/gmi, response);
    inputString = inputString.replace(/%rt%/gmi, rt);
    inputString = inputString.replace(/%correct%/gmi, correct);
    inputString = inputString.replace(/%responseCode%/gmi, responseCode);

    const responseTypeRegex = "(?<responseType>response|rt|correct|responseCode|\\w+)";
    const varTypeIndexRegex = "(?<varTypeIndex>-?[0-9]+)?";
    const varFunctionRegex = "(\\.(?<varFunction>avg|mean|sum|max|min|modal|perc|count|sample|random))?";
    const varFunctionArgsRegex = "(\\((?<varFunctionArgs>.+)\\))?"
    const varIndexRegex = "(\\[(?<varIndex>-?[a-z0-9_]+((,-?[a-z0-9_]+)+|(_-?[a-z0-9_]+))?)\\])?";

    const varReplacementRegex = new RegExp('%' +
        responseTypeRegex +
        varTypeIndexRegex +
        varFunctionRegex +
        varFunctionArgsRegex +
        varIndexRegex +
        '%', 'gmi');

    inputString = generalRegexReplace(inputString, varReplacementRegex, offset);


    /*
     Strategy is to match a responseType and execute the regex giving the appropriate array of values to it accordingly
     (responses, RTs, w/e)
     This will reduce complexity by executing the regex only once per variable as opposed to 4 times per variable 

     Also we'll make use of the named capture groups to minimize string pre-processing (i.e trimming square brackets) 
     and indexes that might shift whenever we extend said regex

    */

    inputString = replaceParticipantDetailsInText(inputString);
    inputString = window.replaceUserVarInText(inputString);

    return inputString;

    // replace participant details in text separated by %, for example %id%
    function replaceParticipantDetailsInText(inputString) {
        for (let i = 0; i < window.saveInfoColumns.length; i++) {
            const regex = new RegExp('%' + window.saveInfoColumns[i] + '%', 'gim');
            if(typeof window.saveInfo[i] === undefined || regex.test(inputString) === false) {
                continue;
            }
            const replacementValue = window.saveInfo[i].toString();
            inputString = inputString.replace("%" + window.saveInfoColumns[i] + "%", replacementValue.replaceAll('\"', ''));
        }
        return inputString;
    }


    function generalRegexReplace(inputString, regex, offset) {
        function translateValue(value, relativeValues, absoluteValues, offset) {

            const trialWithLabel = window.getTrialWithLabel(value);
            let index = trialWithLabel !== -1 ? trialWithLabel + 2 : parseInt(value, 10),
                translated;    
            if (isNaN(index)) {
                return undefined;
            }
            translated = index <= 0 ? relativeValues[relativeValues.length - 1 + index + offset] : absoluteValues[index - 2];

            return translated;
        }

        function applyFeedbackFunction(foundValues, feedbackFunction, variable, functionArgs) {
            var resultString;
            var decimals = 2;
            switch (feedbackFunction) {
                case "avg":
                case "mean":
                    if (variable == "rt") {
                        decimals = 0;
                    }
                    resultString = averageValue(foundValues, decimals);
                    break;
                case "perc":
                    resultString = parseFloat((averageValue(foundValues, 3) * 100).toFixed(1)).toString() + "%";
                    break;
                case "sum":
                    var sum = 0;
                    for (var i = 0; i < foundValues.length; i++) {
                        var currentValue = parseInt(foundValues[i]);
                        if (!isNaN(currentValue)) {
                            sum += currentValue;
                        }
                    }
                    resultString = sum;
                    break;
                case "count":
                    let countTruthy = variable !== "correct" ? true : false;
                    resultString = window.countValues(foundValues, countTruthy);
                    break;
                case "max":
                    var max = Number.NEGATIVE_INFINITY;
                    for (var i = 0; i < foundValues.length; i++) {
                        var currentValue = parseInt(foundValues[i]);
                        if (currentValue > max && !isNaN(currentValue)) {
                            max = currentValue;
                        }
                    }
                    resultString = max == Number.NEGATIVE_INFINITY ? NaN : max;
                    break;
                case "min":
                    var min = Number.POSITIVE_INFINITY;
                    for (var i = 0; i < foundValues.length; i++) {
                        var currentValue = parseInt(foundValues[i]);
                        if (currentValue < min && !isNaN(currentValue)) {
                            min = currentValue;
                        }
                    }
                    resultString = min == Number.POSITIVE_INFINITY ? NaN : min;
                    break;
                case "modal":
                    resultString = modal(foundValues).join(' ');
                    break;
                case "sample":
                    const sampleCount = parseInt(functionArgs, 10);
                    const sampledValues = window.dynamicListsFunctions.sample(foundValues, sampleCount);
                    resultString =  sampledValues.join(';');
                    break;
                case "random":
                    randomOrder = structuredClone(foundValues);
                    shuffle(randomOrder);
                    resultString = randomOrder.join(';');
                    break;
                default:
                    resultString = foundValues.join(';');
            }
            return resultString;
        }

        function getFeedbackValues(values, rowValues, foundValues, offset) {
            var feedbackValues = foundValues;
            //comma seperated values %response[x,y,z]%
            if (feedbackValues.indexOf(',') > 0) {
                feedbackValues = feedbackValues.split(',');
                for (var i = 0; i < feedbackValues.length; i++) {
                    feedbackValues[i] = translateValue(feedbackValues[i], values, rowValues, offset);
                }
            }
            //interval %response[from_to]%
            else if (window.getTrialWithLabel(feedbackValues) == -1 && feedbackValues.indexOf('_') > 0) {
                feedbackValues = feedbackValues.split('_');
                var lowerBound = translateValueToIndex(feedbackValues[0], values, rowValues, offset);
                if (lowerBound < 0) {
                    lowerBound = 0;
                }
                var upperBound = translateValueToIndex(feedbackValues[1], values, rowValues, offset);
                if (feedbackValues[0] <= 0 && feedbackValues[1] <= 0) {
                    feedbackValues = values.slice(lowerBound, upperBound + 1);
                } else {
                    feedbackValues = rowValues.slice(lowerBound, upperBound + 1);
                }
            }
            //single value %response[x]%
            else {
                feedbackValues = [translateValue(feedbackValues, values, rowValues, offset)];
            }

            for (var i = 0; i < feedbackValues.length; i++) {
                feedbackValues[i] = !isNaN(feedbackValues[i]) ? parseInt(feedbackValues[i]) : feedbackValues[i];
            }
            return feedbackValues;
        }

        function modal(foundValues) {
            if (foundValues.length == 0) {
                return null;
            }
            var frequency = {},
                maxCount = 1,
                mostFrequent = [];

            for (var i = 0; i < foundValues.length; i++) {
                if (foundValues[i] == "na") {
                    continue;
                }
                var currentElement = foundValues[i];

                if (frequency[currentElement] == null) {
                    frequency[currentElement] = 1;
                } else {
                    frequency[currentElement]++;
                }

                if (frequency[currentElement] > maxCount) {
                    mostFrequent = [currentElement];
                    maxCount = frequency[currentElement];
                } else if (frequency[currentElement] == maxCount) {
                    mostFrequent.push(currentElement);
                }
            }
            return mostFrequent;
        }


        const valuesMap = new Map([
            ['response', [window.allResponses, window.rowResponses]],
            ['rt', [window.allRTs, window.rowRTs]],
            ['correct', [window.allCorrects, window.rowCorrects]],
            ['responseCode', [window.allResponseCodes, window.rowResponseCodes]],
        ]);

        var currentMatch;
        let finalString = inputString;
        while ((currentMatch = regex.exec(inputString)) !== null) {
            if (currentMatch) {
                const variable = currentMatch.groups.responseType.toLowerCase();
                if(!valuesMap.has(variable)) {
                    const listName = currentMatch.groups.responseType;
                    const values = window.dynamicLists.getDynamicListValues(listName);
                    if(values) {
                        const resultString = applyFeedbackFunction(values, currentMatch.groups.varFunction, 'userVar', currentMatch.groups.varFunctionArgs);
                        finalString = finalString.replace(currentMatch[0], resultString);
                    }
                    continue;
                }

                let values, rowValues;
                [values, rowValues] = valuesMap.get(variable);

                let label = currentMatch.groups.varIndex;
                let valueIndex = parseInt(currentMatch.groups.varTypeIndex);
                let valueFunction = currentMatch.groups.varFunction;
                //%response-X% or %responseX% case
                if (valueIndex && !valueFunction) {
                    var value = translateValue(valueIndex, values, rowValues, offset);
                    if (value !== undefined) {
                        finalString = finalString.replace(currentMatch[0], value);
                    }
                    continue;
                }
                //%response[]% case w/ or w/o functions
                if(label) {
                    var foundValues = label;
                    var currentFunction = valueFunction;
                    if (!foundValues) {
                        continue;
                    }

                    foundValues = getFeedbackValues(values, rowValues, foundValues, offset);

                    var resultString;
                    // w/o function
                    if (!currentFunction) {
                        resultString = foundValues.join(' ');
                        finalString = finalString.replace(currentMatch[0], resultString);
                    }
                    // w/ function
                    else {
                        resultString = applyFeedbackFunction(foundValues, currentFunction, variable);
                        finalString = finalString.replace(currentMatch[0], resultString);
                    }
                    continue;
                }
                //label case
                var row = getTrialWithLabel(label);
                if(!row) {
                    continue;
                }
                var value = rowValues[row];
                if (value !== undefined) {
                    finalString = finalString.replace(currentMatch[0], value);
                }

            }
        }
        return finalString;
    }
}


function replaceUserVarInText(text) {
    const variableRegex = /%(\w+)%/gm;
    return text.replaceAll(variableRegex, function (match, varName) {
        if (typeof window.userVars[varName] !== 'undefined') {

            return formatUserVariable(window.userVars[varName]);
        }

        return match;
    });

    function formatUserVariable(variable) {
        if (typeof variable === 'number') {
            try {
                // floats are displayed with two decimals and integers without any
                return variable.toFixed(2).replace(/\.0+$/, '');
            } catch (e) {
                return variable;
            }
        }
        return variable;
    }
}

/**
 * Translates a trial value to its corresponding index in the values array.
 * This function handles both labeled trials and numeric values, adjusting the index
 * based on relative and absolute values with an optional offset.
 * Example values for value:
 * relative: -2, -3
 * labels: 'label_name'
 * absolute trial numbers (based on execution time): 3, 6, 7
 * 
 * @param {string|number} value - The trial value to translate
 * @param {Array} relativeValues - Array of relative values
 * @param {Array} absoluteValues - Array of absolute values (not used)
 * @param {number} offset - Offset value for index calculation
 * @returns {number|undefined} The translated index or undefined if value is invalid
 */
function translateValueToIndex(value, relativeValues, absoluteValues, offset) {
    const trialWithLabel = window.getTrialWithLabel(value);
    value = trialWithLabel !== -1 ? trialWithLabel + 2 : parseInt(value);
    if (isNaN(value)) {
        return undefined;
    }
    if (value <= 0) {
        return relativeValues.length - 1 + value + offset;
    }

    return value - 2;
}